<template>
    <div class="money" :style="{ width: 130 + cards.length * 60 +'px' }">
        <div class="cards">
            <div class="card" v-for="(card, index) of cards" :key="index"
                :style="{ 
                    left: index * 60 + 'px', 
                    'z-index': 1000 - index,
                    height: 80 - index * 5 + 'px',
                    'background-image': background
                }">
                <div class="title" v-if="index == 0">{{ title }}</div>
                <div class="value">
                    ¥ <span>{{ card }}</span>
                </div>
            </div>
        </div>
        <div class="shadow"></div>
    </div>
</template>

<script>
export default {
    props: { 
        "title": String, 
        "value": {},
        "color": {
            default: () => ["#b7bec4", "#898d90"]
        }
    },
    computed: {
        cards() {
            if (typeof this.value === 'number') return [this.value];
            else return this.value;
        },
        background() {
            return `linear-gradient(to bottom right, ${this.color[0]}, ${this.color[1]})`
        }
    }
}
</script>

<style lang="less" scoped>
.money {
    height: 85px;
    overflow: hidden;
    flex-shrink: 0;
}
.cards {
    height: 85px;
    position: relative;;
    margin: 0 10px;
}
.card {
    position: absolute;
    width: 170px;
    bottom: 0px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    box-shadow: 2px -2px 6px rgba(0, 0, 0, 0.1);
    .title, .value {
        position: absolute;
    }
    .title {
        left: 8px;
        bottom: 15px;
    }
    .value {
        font-size: 20px;
        right: 16px;
        span {
            font-family: fantasy;
            font-size: 28px;
        }
    }
}
.shadow {
    height: 5px;
    bottom: -5px;
    position: relative;
    box-shadow: 0px -4px 12px black;
    z-index: 1001;
    margin: 0 8px;
}
</style>